<style>
div#side-pane {
  padding: .5em;
  position: absolute;
  top: 30%;
  right: 0;
  border: none;
  background-color: var(--app-panel-bg);
  border-radius: 5px 0 0 5px;
}

a.button.is-active img.custom-icon {
  filter:  brightness(0) invert(1);
}

div.field.avatar-ct {
  display: flex;
  flex-direction: row;
}

div.field.avatar-ct div.dropdown {
  justify-content: center;
  flex-grow: 1;
}

/* div#controls a.button {
  background-color: #000;
} */
</style>

<template>
  <div id="side-pane">
    <div id="controls" v-bind:class="{hidden: !visible}">
      <div v-if="showSearchButton" v-show="!currentShape.indexID && mode != 'free'" class="field">
        <a class="button" @click="searchButtonClick" title="Search for a new address">
          <span class="icon">
            <magnify-icon />
          </span>
        </a>
      </div>
      <div class="field" v-show="mode == 'move' && currentShape.indexID">
        <a class="button" @click="clearCurrentShape()" title="Done with this layer">
          <span class="icon">
            <check-icon />
          </span>
        </a>
      </div>
      <div class="field" v-show="mode == 'draw' && currentShape.paths && (currentShape.type == 'area' && currentShape.paths.length > 2 || currentShape.type == 'distance' && currentShape.paths.length > 1)">
        <a class="button" @click="setMode('move')" title="Done changing points">
          <span class="icon">
            <check-icon />
          </span>
        </a>
      </div>
      <div class="field" v-show="mode == 'move'">
        <b-dropdown position="is-bottom-left" >
          <template #trigger>
            <a @click.prevent class="button" title="Create a new measurement">
              <span class="icon"><tape-measure-icon /></span>
            </a>
          </template>
          <b-dropdown-item @click="addLayer('area','free')" :class="{'is-primary is-active': mode == 'free'}">
            <span class="icon">
              <draw-icon />
            </span>
            <span>Area (free draw)</span>
          </b-dropdown-item>
          <b-dropdown-item @click="addLayer('area','rectangle')">
            <span class="icon">
              <shape-rectangle-plus-icon />
            </span>
            <span>Area (rectangle)</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="field" v-show="mode == 'free' || (currentShape.paths && (currentShape.type == 'area' && currentShape.paths.length < 3 || currentShape.type == 'distance' && currentShape.paths.length < 2))">
        <a class="button" @click="cancelFreeDraw" title="Cancel drawing">
          <span class="icon">
            <close-circle-icon />
          </span>
        </a>
      </div>
      <div v-show="mode == 'move'" class="field">
        <a class="button" @click="showTutorial" title="Helpful tips">
          <span class="icon">
            <help-icon />
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, toRef } from 'vue'
import { useRouter } from 'vue-router'
import { useMainStore } from '@/stores/main'
import { useDialogsStore } from '@/stores/dialogs'

import { NEW_AREA } from '../constants'
import TapeMeasure from 'vue-material-design-icons/TapeMeasure.vue'

export default {
  components: {
    TapeMeasure
  },
  emits: ['add-shape-click'],
  props: {
    minimized: {
      type: Boolean,
      default: false
    },
    showSearchButton: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const router = useRouter()
    const mainStore = useMainStore()
    const dialogsStore = useDialogsStore()

    const inputAddress = ref('')
    const visible = ref(true)

    const currentShape = computed(() => mainStore.currentShape)
    const address = toRef(mainStore, 'address')
    const mode = toRef(mainStore, 'mode')

    const setTutorialModalVisibility = (visibility) => {
      mainStore.setTutorialModalVisibility(visibility)
    }

    const setMode = (newMode) => {
      mainStore.setMode(newMode)
    }

    const searchButtonClick = () => {
      dialogsStore.confirm(0, `Searching for a new address will remove all measurement layers from the map. <br><br><span class="has-text-weight-bold">Are you sure?</span>`, {
        title: 'Warning',
        confirmText: 'Yes, search for a new address',
        cancelText: 'Cancel',
        type: 'is-primary',
        onConfirm: async () => {
          await mainStore.resetState()
          router.replace('/flow/address-search')
        }
      })
    }

    const toggleControlVisibility = (vis) => {
      visible.value = (vis === null || vis) ? true : false
    }

    const deleteCurrentShape = () => {
      mainStore.deleteShape({ shape: currentShape.value })
    }

    const clearCurrentShape = () => {
      mainStore.setCurrentShape(null)
    }

    const addLayer = (type = 'area', shape = 'free') => {
      emit('add-shape-click', new NEW_AREA({
        type,
        shape
      }))
    }

    const cancelFreeDraw = () => {
      deleteCurrentShape()
    }

    const showTutorial = () => {
      setTutorialModalVisibility(true)
    }

    return {
      inputAddress,
      visible,
      currentShape,
      address,
      mode,
      setMode,
      searchButtonClick,
      toggleControlVisibility,
      deleteCurrentShape,
      clearCurrentShape,
      addLayer,
      cancelFreeDraw,
      showTutorial
    }
  }
}
</script>
